import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import cn from "~/utils/cn";
import Logo from "../../ui/Logo";
import { INSTAGRAM_URL, type LandingData } from "../types";

const persianYear = () => new Intl.DateTimeFormat("fa-IR-u-ca-persian", { year: "numeric" }).format(new Date());
const linkCls = "inline-flex min-h-11 items-center rounded-btn px-2.5 text-[15px] md:px-3 text-ink-2 transition-colors duration-200 hover:bg-accent-soft hover:text-ink";

export default function LandingFooter({
  data,
  className,
  width = "max-w-[1200px]",
}: {
  data: Pick<LandingData, "loggedIn">;
  className?: string;
  width?: string;
}) {
  const { t } = useTranslation();
  const external = { target: "_blank", rel: "noopener noreferrer" };
  return (
    <footer className={cn("border-t border-line pb-[calc(env(safe-area-inset-bottom)+28px)] pt-8", className)}>
      <div className={cn("mx-auto flex w-full flex-col gap-5 px-[var(--gutter)] md:flex-row md:flex-wrap md:items-center md:gap-x-8", width)}>
        <div className="flex flex-col gap-2">
          <Logo />
          <p className="max-w-[52ch] text-sm leading-7 text-ink-3">{t("ui.landing.footer.tagline")}</p>
        </div>
        <ul className="-mx-2.5 flex flex-wrap md:mx-0 md:ms-auto">
          <li>
            <a href="https://fonta.org/terms" className={linkCls} {...external}>
              {t("ui.landing.footer.terms")}
            </a>
          </li>
          <li>
            <a href="https://fonta.org/privacy" className={linkCls} {...external}>
              {t("ui.landing.footer.privacy")}
            </a>
          </li>
          <li>
            <a href={INSTAGRAM_URL} className={linkCls} {...external}>
              {t("ui.landing.footer.instagram")}
            </a>
          </li>
          <li>
            <Link to={data.loggedIn ? "/profile" : "/login"} prefetch="intent" className={linkCls}>
              {data.loggedIn ? t("ui.landing.nav.account") : t("ui.landing.nav.login")}
            </Link>
          </li>
        </ul>
        <p className="text-sm text-ink-3 md:w-full">{t("ui.landing.footer.rights", { year: persianYear() })}</p>
      </div>
    </footer>
  );
}
